import JonOrderService from './job-order.service';
import ClientService from './client.service';
import EstimateService from './estimate.service';
import ServiceService from './service.service';
import NotificationService from './notification.service';
import AuthService from './auth.service';
import UserService from './user.service';
import RoleService from './role.service';
import HttpService from './http.service';
import SettingService from './setting.service';
import NoteService from './note.service';
import DashboardService from './dashboard.service';

export const service = {
  jobOrder: JonOrderService(HttpService),
  client: ClientService(HttpService),
  service: ServiceService(HttpService),
  estimate: EstimateService(HttpService),
  notification: NotificationService,
  auth: AuthService(HttpService),
  user: UserService(HttpService),
  role: RoleService(HttpService),
  dashboard: DashboardService(HttpService),
  note: NoteService(HttpService),
  setting: SettingService(HttpService),
  https: HttpService,

};
